export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10801.79dc3531.jpg";